import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyInformationSectionComponent } from '../../../sections/rural/property-information-section/property-information-section.component';
import { PropertyPageBase } from '../../property-page-base';
import { PropertyAgentContactDetailsSectionComponent } from '../../../sections/residential-for-sale-agent/property-agent-contact-details-section/property-agent-contact-details-section.component';
import { PropertySaleDetailsSectionComponent } from '../../../sections/residential-for-sale-agent/property-sale-details-section/property-sale-details-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyOpenHomeTimesSectionComponent } from '../../../sections/residential-for-sale/property-open-home-times-section/property-open-home-times-section.component';

@Component({
    templateUrl: './property-information-page.component.html',
    styleUrls: ['./property-information-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { 'data-variant': 'rural' },
    standalone: false
})
export class PropertyInformationComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(PropertyInformationSectionComponent, {
        read: PropertyInformationSectionComponent
    })
    propertyInformationSection: PropertyInformationSectionComponent;

    @ViewChild(PropertyOpenHomeTimesSectionComponent, {
        read: PropertyOpenHomeTimesSectionComponent
    })
    propertyOpenHomeTimesSection: PropertyOpenHomeTimesSectionComponent;

    @ViewChild(PropertySaleDetailsSectionComponent, {
        read: PropertySaleDetailsSectionComponent
    })
    propertySaleDetailsSectionComponent: PropertySaleDetailsSectionComponent;

    @ViewChild(PropertyAgentContactDetailsSectionComponent, {
        read: PropertyAgentContactDetailsSectionComponent
    })
    propertyAgentContactDetailsSection: PropertyAgentContactDetailsSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyInformation, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyInformationSection);
        super.registerSection(this.propertySaleDetailsSectionComponent);
        super.registerSection(this.propertyAgentContactDetailsSection);
        super.registerSection(this.propertyOpenHomeTimesSection);
    }
}
